import { Card, Col, ConfigProvider, Row, Skeleton, Space, Spin } from "antd"
import React, { useEffect } from "react"
import { useGetPerson } from "../network/usePerson"
import { Container } from "./Container"
import { updateSiteMetadata } from "../helpers/siteMetadata"

export function ThemeProvider({ children }) {
  const IWIN_PRIMARY_COLOR = "#294F6D"
  const personQuery = useGetPerson({
    authenticated: !window.location.pathname.includes("auth"),
  })

  useEffect(() => {
    if (!personQuery.isLoading && personQuery.data) {
      const products = personQuery.data?.company?.configuration?.products
      const hasProductConfig = products && Object.hasOwn(products, window.location.origin)
      const productConfig = hasProductConfig ? products[window.location.origin] : null

      const config = productConfig || personQuery.data?.company?.configuration
      const site = config?.site || config?.products?.site

      if (site) {
        updateSiteMetadata(site)
      } else {
        const faviconUrl = productConfig?.favicon || personQuery.data?.company?.imageUrl
        if (faviconUrl) {
          updateSiteMetadata({ favicon: faviconUrl })
        }
      }

      if (hasProductConfig) {
        ConfigProvider.config({
          theme: {
            primaryColor: productConfig?.primaryColour || IWIN_PRIMARY_COLOR,
          },
        })
      } else {
        ConfigProvider.config({
          theme: {
            primaryColor: personQuery.data?.company?.configuration?.primaryColour || IWIN_PRIMARY_COLOR,
          },
        })
      }
    }
  }, [personQuery.isLoading, personQuery.data])

  return <>{children}</>
}
